import classNames from 'classnames';
import { createElement } from 'react';

import { type CellProps, type ColumnProps } from '@/shared/hooks/table/types';
import { type Obj } from '~/common/types';

type Props = Omit<CellProps, 'column'> & {
  column: ColumnProps;
  className?: string;
};

const DefaultTableCellContent: React.FC<Props> = (props) => {
  const { className, column, value } = props;

  if (column.customCellComponent) {
    return createElement(column.customCellComponent, props);
  }
  return <div className={classNames('break-words', className)}>{value || '-'}</div>;
};

type WidenedProps = Obj & Props & React.Attributes;

const WidenedDefaultTableCellContent = (props: WidenedProps) => (
  <DefaultTableCellContent {...props} />
);

export default {
  Content: DefaultTableCellContent,
  DefaultTableCell: WidenedDefaultTableCellContent,
};
